import { gql } from "@apollo/client";

export const GET_COMMISSARY_ORDERS = gql`
  query commissary_orders($where: order_commissary_bool_exp) {
    order_commissary(where: $where, order_by: { created_at: desc }) {
      id
      event_id
      vendor_id
      user_id
      status
      notes
      rejection_reason
      organizer_notes
      subtotal
      tax
      total
      items
      estimated_ready_time
      fulfilled_at
      sms_notify
      created_at
      updated_at
      vendor {
        id
        name
        poc_name
        poc_phone
      }
      user {
        first_name
        last_name
        phone_number
      }
    }
  }
`;

export const GET_COMMISSARY_ORDER = gql`
  query commissary_order_by_pk($id: Int!) {
    order_commissary_by_pk(id: $id) {
      id
      event_id
      vendor_id
      user_id
      status
      notes
      rejection_reason
      organizer_notes
      subtotal
      tax
      total
      items
      estimated_ready_time
      fulfilled_at
      sms_notify
      created_at
      updated_at
      vendor {
        id
        name
        poc_name
        poc_phone
      }
      user {
        first_name
        last_name
        phone_number
      }
    }
  }
`;

export const GET_COMMISSARY_ITEMS = gql`
  query commissary_items($where: items_bool_exp) {
    items(where: $where, order_by: { category: asc, name: asc }) {
      id
      name
      description
      category
      price
      image_url
      is_active
      event_id
      vendor_id
      size
      order_quantity_limit
    }
  }
`;

export const GET_VENDORS_FOR_COMMISSARY = gql`
  query vendors_for_commissary($where: vendors_bool_exp) {
    vendors(where: $where, order_by: { name: asc }) {
      id
      name
      poc_name
      poc_phone
    }
  }
`;
